export interface PostIframeProps {
  url: string | null
}

export default function PostIframe({ url }: PostIframeProps) {
  if (!url) return null

  return (
    <div className="mb-10 h-auto overflow-hidden">
      <iframe
        className="mx-auto h-[600px] w-full max-w-full rounded-lg border border-inside md:max-w-[70%]"
        src={url}
        title={`Iframe of ${url}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen={false}
        loading="lazy"
      />
    </div>
  )
}
